// removed by extract-text-webpack-plugin
module.exports = {"desc":"_1ajIIwL0Ajv1JGfNSZB-QD_1","content":"GM8V-V3zrff9woVHSwGJI_1","btn":"_1RV4YdvfJuOlmsiLsShaij_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_1","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22256147","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/dashboard/components/form/DashboardImportForm.vue
// module id = 4HbG
// module chunks = 75